module.exports = __webpack_public_path__ + "static/media/circle-true.b903e6ca.svg";